module.exports = __webpack_public_path__ + "static/media/yellow-center-star-icon.401072a8.png";